import { customToast, defaultOptions } from "../../../../../../../../components/toast/custom-react-toastify/v1";
import { erpItemDataConnect } from "../../../../../../../../data_connect/erpItemDataConnect"

export function useApiHook() {
    const onReqSearchItemCount = async (
        options = {headers: {}, params: {}},
        callbackFn = {
            success: (results, response) => {},
        }
    ) => {
        await erpItemDataConnect().count(options.headers, options.params)
            .then(res => {
                if (res.status === 200) {
                    callbackFn.success(res?.data?.data, res);
                }
            })
            .catch(err => {
                const res = err.response;
                customToast.error(res?.data?.memo, {
                    ...defaultOptions,
                    toastId: res?.data?.memo
                })
            })
    }

    return {
        onReqSearchItemCount
    }
}